import store from "@/store";
import Vue from "vue";

export async function protectedPage(to, from, next) {
    try {
        const token = localStorage.getItem("token");

        // Verifica se o token está presente
        if (!token) {
            Vue.fire({
                type: 'error',
                title: 'Erro',
                text: 'Você precisa estar logado para acessar esta página.',
                timer: 3000,
            });
            return next({ name: "Client" });
        }

        // Recupera os dados do usuário
        let user = await store.dispatch("App/getUserData", token);

        // Verifica se o token expirou (implementação comentada)
        // if (moment().now() > user.date_token_expire_at) {
        //     localStorage.removeItem("token");
        //     return next({ name: "Merchant" });
        // }

        // Se os dados do usuário forem válidos, permite a navegação
        console.log("Dados do usuário recuperados:", user);
        if (user && Object.keys(user).length > 0) {
            return next();
        } else {
            return next({ name: "Client" });
        }
    } catch (e) {
        console.error(e); // Loga o erro para depuração
        localStorage.setItem('scrollToElement', true);
        Vue.fire({
            type: 'error',
            title: 'Erro',
            text: 'Você precisa estar logado para acessar esta página.',
            timer: 3000,
        });
        return next({ name: "Client" });
    }
}